module.exports = __webpack_public_path__ + "7e3e97648be8d6a12c70fb9364fce3ce.svg";